import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Lock4Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M25.2391 11.2516H24.0863V8.7044C24.0863 4.45912 20.4631 1 16.0165 1C11.5698 1 7.93017 4.45912 7.93017 8.7044V11.2516H6.77734C4.96574 11.2516 3.5 12.6509 3.5 14.3805V27.8711C3.5 29.6006 4.96574 31 6.77734 31H25.2227C27.0343 31 28.5 29.6006 28.5 27.8711V14.3805C28.5 12.6509 27.0343 11.2516 25.2227 11.2516H25.2391ZM10.8946 8.7044C10.8946 6 13.2003 3.81447 16.0165 3.81447C18.8327 3.81447 21.1383 6.01572 21.1383 8.7044V11.2516H10.8946V8.7044Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
